import { useState } from "react";
import { Send } from "lucide-react";
import { Button } from "../ui/button";
import IcertiDialog from "./IcertiDialog";

// iCerti button of the Planning detail panel + its send dialog. onChanged(pedido)
// is called after a send/refresh so the Planning can reload and update the open appointment.
const IcertiButton = ({ appointment, onChanged }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        className="w-full mt-2"
        onClick={() => setOpen(true)}
        data-testid="open-icerti"
      >
        <Send size={14} className="mr-2" />
        {appointment.icerti?.pedido ? "iCerti · enviado" : "Enviar a iCerti"}
      </Button>
      <IcertiDialog appointment={appointment} open={open} onClose={() => setOpen(false)} onChanged={onChanged} />
    </>
  );
};

export default IcertiButton;
